import { Component } from 'react';

export default class ErrorBoundary extends Component {
    state = { hasError: false, error: null };

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            const Fallback = this.props.fallback;
            if (Fallback) return <Fallback error={this.state.error} />;
            return (
                <div className="error-boundary-fallback" style={{
                    padding: 'var(--spacing-xl)',
                    maxWidth: '600px',
                    margin: '0 auto',
                    background: 'var(--color-bg-card)',
                    borderRadius: 'var(--radius-lg)',
                    border: '1px solid var(--color-border)'
                }}>
                    <h2 style={{ color: 'var(--color-error)', marginBottom: 'var(--spacing-md)' }}>
                        Something went wrong
                    </h2>
                    <p style={{ color: 'var(--color-text-secondary)', marginBottom: 'var(--spacing-md)' }}>
                        This page failed to load. Please refresh or go back to the main page.
                    </p>
                    <pre style={{
                        fontSize: 'var(--font-size-sm)',
                        overflow: 'auto',
                        padding: 'var(--spacing-md)',
                        background: 'var(--color-bg-primary)',
                        borderRadius: 'var(--radius-md)',
                        color: 'var(--color-text-tertiary)'
                    }}>
                        {this.state.error?.message || String(this.state.error)}
                    </pre>
                    <a href="/" style={{
                        display: 'inline-block',
                        marginTop: 'var(--spacing-md)',
                        padding: '10px 24px',
                        background: 'var(--color-accent-gradient)',
                        color: '#fff',
                        borderRadius: 'var(--radius-md)',
                        textDecoration: 'none',
                        fontWeight: 500
                    }}>
                        Back to Home
                    </a>
                </div>
            );
        }
        return this.props.children;
    }
}
